var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFactorRiesgoImss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57 57",
    style: {
      enableBackground: "new 0 0 57 57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3ABCA7"
    },
    d: "M44.636,52H9.364C4.745,52,1,48.255,1,43.636V8.364C1,3.745,4.745,0,9.364,0h35.272 C49.255,0,53,3.745,53,8.364v35.272C53,48.255,49.255,52,44.636,52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45,14H27c-0.553,0-1-0.447-1-1s0.447-1,1-1h18c0.553,0,1,0.447,1,1S45.553,14,45,14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45,28H27c-0.553,0-1-0.447-1-1s0.447-1,1-1h18c0.553,0,1,0.447,1,1S45.553,28,45,28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M45,42H27c-0.553,0-1-0.447-1-1s0.447-1,1-1h18c0.553,0,1,0.447,1,1S45.553,42,45,42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M13.07,17c-0.209,0-0.42-0.065-0.599-0.2L7.9,13.371c-0.442-0.331-0.532-0.958-0.2-1.399 c0.331-0.443,0.958-0.53,1.399-0.2l3.822,2.866L19.17,7.35c0.359-0.42,0.991-0.468,1.409-0.108c0.42,0.359,0.469,0.99,0.108,1.409 l-6.857,8C13.634,16.881,13.354,17,13.07,17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M13.07,31c-0.209,0-0.42-0.065-0.599-0.2L7.9,27.371c-0.442-0.331-0.532-0.958-0.2-1.399 c0.331-0.443,0.958-0.53,1.399-0.2l3.822,2.866l6.248-7.288c0.359-0.42,0.991-0.468,1.409-0.108 c0.42,0.359,0.469,0.99,0.108,1.409l-6.857,8C13.634,30.881,13.354,31,13.07,31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M13.07,45.999c-0.209,0-0.42-0.065-0.599-0.2L7.9,42.37c-0.442-0.331-0.532-0.958-0.2-1.399 c0.331-0.443,0.958-0.531,1.399-0.2l3.822,2.866l6.248-7.287c0.359-0.42,0.991-0.468,1.409-0.108 c0.42,0.359,0.469,0.99,0.108,1.409l-6.857,7.999C13.634,45.88,13.354,45.999,13.07,45.999z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#556080"
    },
    d: "M56,43.846l-1.444-0.278c-2.143-0.412-3.125-2.916-1.835-4.675l0.907-1.236l-1.958-1.958 l-1.217,0.825c-1.806,1.224-4.272,0.148-4.604-2.008L45.615,33h-2.769l-0.359,1.865c-0.403,2.096-2.818,3.096-4.585,1.899 l-1.572-1.065l-1.958,1.958l0.907,1.236c1.29,1.76,0.308,4.263-1.835,4.675L32,43.846v2.769l1.515,0.233 c2.157,0.332,3.232,2.797,2.008,4.604l-0.825,1.217l1.958,1.958l1.236-0.907c1.76-1.29,4.263-0.308,4.675,1.835L42.846,57h2.769 l0.164-1.066c0.339-2.204,2.896-3.263,4.694-1.944l0.869,0.638l1.958-1.958l-0.825-1.217c-1.224-1.806-0.148-4.272,2.008-4.604 L56,46.615V43.846z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 44,
    cy: 45,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M44,50c-2.757,0-5-2.243-5-5s2.243-5,5-5s5,2.243,5,5S46.757,50,44,50z M44,42 c-1.654,0-3,1.346-3,3s1.346,3,3,3s3-1.346,3-3S45.654,42,44,42z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactorRiesgoImss);
export default __webpack_public_path__ + "static/media/factor_riesgo_imss.e64d7d160a78807df621cc93b4101170.svg";
export { ForwardRef as ReactComponent };